(function (M) {
  if (!M) return;
  var d = document, about = d.querySelector('.mm-about-sec');
  if (!about) return;
  M.tag('.mm-hero .p-c', 'fade');
  M.tag(M.all('.mm-hero .p-l, .mm-hero .p-r').filter(function (el) {
    return getComputedStyle(el).display !== 'none';
  }), 'fade', { d: 0.25 });
  [['.mm-hero .p-l', -14], ['.mm-hero .p-c', -14], ['.mm-hero .p-r', -14]].forEach(function (p) {
    var el = d.querySelector(p[0]);
    if (el) el.setAttribute('data-mo-par', p[1]);
  });
  M.tag('.mm-about h2', 'up');
  M.tag('.mm-about .tx', 'up', { d: 0.12 });
  var circles = about.querySelector('.mm-circles');
  if (circles) {
    var paths = '';
    for (var i = 0; i < 6; i++) {
      var y = 14 + i * 14;
      paths += '<path pathLength="1" style="--i:' + i + '" d="M0 ' + y + ' C 240 ' + (y - 7) + ', 480 ' + (y + 7) + ', 720 ' + y + ' S 1200 ' + (y - 7) + ', 1440 ' + y + '"/>';
    }
    M.add(circles, '<svg class="mm-layers mo-deco" data-mo-play viewBox="0 0 1440 98" preserveAspectRatio="none" aria-hidden="true">' + paths + '</svg>', 'afterbegin');
    M.all('.mm-badge', circles).forEach(function (b, k) {
      M.tag(b, 'flip', { d: 0.2 + (M.narrow ? (k % 2) * 0.12 : k * 0.12) });
    });
  }
  M.tag('.mm-steps-sec > h2', 'up');
  M.tag('.mm-steps-sec > .mm-pre', 'up', { d: 0.08 });
  M.tag('.mm-step', 'rise', { d: 0.1, step: M.narrow ? 0 : 0.16 });
  M.tag('.mm-faq .kick, .mm-faq h2', 'up', { step: 0.1 });
  M.tag('.mm-acc .mm-itm', 'up', { d: 0.15, step: 0.08 });
  M.tag('.mm-cta .kick, .mm-cta h2, .mm-cta .mm-btn', 'up', { step: 0.12 });
  M.tag('.mm-cta img', 'mask', { d: 0.15 });
  M.all('.mm-gal .mm-pc').forEach(function (c, k) {
    M.tag(c, 'up', { d: (k % (M.narrow ? 2 : 4)) * 0.1 });
  });
  M.tag('.mm-strip p, .mm-strip img', 'up', { step: 0.15 });
})(window.FJKMotion);
